<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-form @submit.prevent>
          <b-form-group label="انتخاب دوره مورد نظر" label-for="course-picker">
            <v-select
              @search="handleSearch"
              @open="onOpen"
              @close="onClose"
              id="course-picker"
              dir="rtl"
              :filterable="false"
              v-if="courseList"
              :reduce="(course) => course"
              v-model="selectedCourse"
              :options="courseList"
              label="title"
              placeholder="دوره را انتخاب کنید"
            >
              <template #no-options>هیچ دوره‌ای جهت نمایش وجود ندارد</template>
              <template #list-footer>
                <li v-show="hasNextPage" ref="load" class="loader">
                  در حال لود...
                </li>
              </template>
            </v-select>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
import { BOverlay, BRow, BCol, BForm, BFormGroup } from "bootstrap-vue";
import vSelect from "vue-select";
import { GetAllCourses } from "@/libs/Api/Course";

export default {
  emits: ["getCourse", "getCourseTypeId", "getCoursePrice"],
  mounted() {
    this.getAllCourses();
    this.observer = new IntersectionObserver(this.infiniteScroll);
  },
  props: {
    defaultCourseId: {
      type: Number,
      required: false,
      default: null,
    },
  },
  watch: {
    courseList: {
      handler(val) {
        if (this.defaultCourseId) {
          this.selectedCourse = this.courseList.find(
            (item) => item.courseId == this.defaultCourseId
          );
        }
      },
    },
    selectedCourse: {
      handler(val) {
        if (!val) {
          this.$emit("getCourse", null);
          return;
        }
        this.$emit("getCourse", val.courseId);
        this.$emit("getCourseTypeId", val.courseTypeId);
        this.$emit("getCoursePrice", val.price);
      },
    },
    pageNumber: {
      handler(val) {
        this.getAllCourses();
      },
    },
  },
  data() {
    return {
      courseList: [],
      selectedCourse: null,
      searchVal: null,
      timeout: null,
      isLoading: false,
      observer: null,
      pageNumber: 1,
      count: 10,
      totalCount: null,
    };
  },
  methods: {
    clearSelectedCourse() {
      this.selectedCourse = null;
    },
    handleSearch(searchValue, loadingFn) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(async () => {
        this.searchVal = searchValue;
        loadingFn(true);
        await this.getAllCourses();
        loadingFn(false);
      }, 300);
    },
    async getAllCourses() {
      try {
        this.isLoading = true;
        let _this = this;
        let reqParams = {
          count: _this.count,
          pageNumber: _this.pageNumber,
        };
        if (this.searchVal && this.searchVal != "") {
          reqParams["searchCommand"] = this.searchVal;
        }
        let getAllCourses = new GetAllCourses(_this);
        getAllCourses.setRequestParam(reqParams);
        await getAllCourses.fetch(
          function (response) {
            if (response.isSuccess) {
              _this.courseList.push(...response.data.courses);
              _this.totalCount = response.data.coursesCount;
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async infiniteScroll([{ isIntersecting, target }]) {
      if (isIntersecting) {
        if (this.hasNextPage) {
          this.pageNumber++;
        }
      }
    },
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load);
      }
    },
    onClose() {
      this.observer.disconnect();
    },
  },
  computed: {
    hasNextPage() {
      if (this.totalCount && this.totalCount / this.count > this.pageNumber) {
        return true;
      }
      return false;
    },
  },
  components: {
    vSelect,
    BOverlay,
    BRow,
    BCol,
    BForm,
    BFormGroup,
  },
};
</script>
